import ApiService from "@/core/services/api.service";

let timer = null;
let pending = null;

export function previewSale(payload) {
  if (timer) clearTimeout(timer);

  return new Promise((resolve, reject) => {
    timer = setTimeout(async () => {
      try {
        pending = payload;
        const result = await ApiService.post("sales/preview", payload);
        if (pending === payload) resolve(result);
      } catch (e) {
        reject(e);
      }
    }, 280);
  });
}

export function clearPreviewTimer() {
  if (timer) clearTimeout(timer);
  pending = null;
}
